import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getOrderGeneratorsFieldsWorksServices(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].GET_ORDER_GENERATORS_FIELDS_WORKS_SERVICES,
		options
	)
}

function _getOrderGeneratorsFieldsWorksService(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].GET_ORDER_GENERATORS_FIELDS_WORKS_SERVICE,
		options
	)
}

function _createOrderGeneratorsFieldsWorksService(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].CREATE_ORDER_GENERATORS_FIELDS_WORKS_SERVICE,
		options
	)
}

function _putOrderGeneratorsFieldsWorksService(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].PUT_ORDER_GENERATORS_FIELDS_WORKS_SERVICE,
		options
	)
}

function _patchOrderGeneratorsFieldsWorksService(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].PATCH_ORDER_GENERATORS_FIELDS_WORKS_SERVICE,
		options
	)
}

function _deleteOrderGeneratorsFieldsWorksService(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].DELETE_ORDER_GENERATORS_FIELDS_WORKS_SERVICE,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].GET_ORDER_GENERATORS_FIELDS_WORKS_SERVICES]: _getOrderGeneratorsFieldsWorksServices,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].GET_ORDER_GENERATORS_FIELDS_WORKS_SERVICE]: _getOrderGeneratorsFieldsWorksService,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].CREATE_ORDER_GENERATORS_FIELDS_WORKS_SERVICE]: _createOrderGeneratorsFieldsWorksService,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].PUT_ORDER_GENERATORS_FIELDS_WORKS_SERVICE]: _putOrderGeneratorsFieldsWorksService,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].PATCH_ORDER_GENERATORS_FIELDS_WORKS_SERVICE]: _patchOrderGeneratorsFieldsWorksService,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].DELETE_ORDER_GENERATORS_FIELDS_WORKS_SERVICE]: _deleteOrderGeneratorsFieldsWorksService,
}